import Loading from 'parog-web/components/cnam-services-access-form/process/loading';
import gt from 'ember-truth-helpers/helpers/gt';
import add from 'ember-math-helpers/helpers/add';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type DmpRetrievalContext from 'parog-web/contexts/dmp-retrieval-context';

export default <template>
  <Loading @context={{@context}} @onDismiss={{@onDismiss}}>
    <:title>
      {{#if @context.hasRetrievedHr}}
        <b>L'historique de remboursement a bien été récupérée.</b><br />
      {{/if}}
      Nous tentons une récupération des documents provenant du DMP du patient.
    </:title>
    <:content>
      {{#if (gt @context.totalDocumentsToRetrieve 0)}}
        <br />
        Récupération des documents :
        {{add @context.documentRetrievingIndex 1}}
        /
        {{@context.totalDocumentsToRetrieve}}.
      {{/if}}
      {{#if (gt @context.totalDocumentsToUpdate 0)}}
        <br />
        Mise à jour des documents :
        {{add @context.documentUpdatingIndex 1}}
        /
        {{@context.totalDocumentsToUpdate}}.
        <br />
      {{/if}}
      {{#if (gt @context.nonHrDocumentsOnError.length 0)}}
        <br />
        Documents en erreur de récupération :
        {{@context.nonHrDocumentsOnError.length}}.
        <br />
      {{/if}}
      {{#if (gt @context.nonHrDocumentsUpdatesOnError.length 0)}}
        <br />
        Documents en erreur de mise à jour :
        {{@context.nonHrDocumentsUpdatesOnError.length}}.
        <br />
      {{/if}}
    </:content>
  </Loading>
</template> satisfies TemplateOnlyComponent<{
  Args: {
    context: DmpRetrievalContext;
    onDismiss: () => void;
  };
}>;
